import BaseAPIService from '../base/base-api-service';
import LocationModel from 'src/model/location.model';

class LocationService extends BaseAPIService<LocationModel> {
  public endpoint: string = '/navapp/v1/location/locations';

  constructor() {
    super(LocationModel);
  }

  public getLocations(
    zipCode: string,
    isPickUpOrDelivery: boolean = false,
    wareHouseNumber?: string
  ): Promise<LocationModel[]> {
    return this.getByParams(
      `${this.endpoint}/${zipCode}`,
      { isPickUpOrDelivery, wareHouseNumber },
      {}
    );
  }
}

const locationServiceInstance = new LocationService();
Object.freeze(locationServiceInstance);

export default locationServiceInstance;
